import {
  Auth0AccountRole,
  MeetingStudentAdminResponse,
  MeetingStudentLimitedResponse,
  MeetingTutorAdminResponse,
  MeetingTutorLimitedResponse,
  StudentAdminResponse,
  StudentLimitedResponse,
  TutorAdminResponse,
  TutorLimitedResponse,
} from "client/openapi";
import Avatar from "components/Avatar";
import { ReactNode } from "react";
import { concatenateName } from "util/concatenateName";
import { getUserColor } from "util/contextColor";
import { generateInitials } from "util/generateInitials";
import { safePhoto } from "util/safePhoto";

export default function MeetingAttendee({
  attendee,
  userType,
  children,
  onClick,
  newView = false,
  append,
}: {
  attendee:
    | StudentLimitedResponse
    | TutorLimitedResponse
    | MeetingStudentLimitedResponse
    | MeetingStudentAdminResponse
    | MeetingTutorAdminResponse
    | MeetingTutorLimitedResponse
    | StudentAdminResponse
    | TutorAdminResponse;
  userType?: Auth0AccountRole;
  children: React.ReactNode;
  onClick?: () => void;
  newView?: boolean;
  append?: ReactNode;
}) {
  // A tutor's booking page photo replaces their initials.
  const photo =
    "tutor_web_page" in attendee
      ? attendee.tutor_web_page?.photo_url
      : "tutor" in attendee
      ? attendee.tutor?.tutor_web_page?.photo_url
      : undefined;

  return (
    <div className="meeting-dialog--attendee">
      <div className={onClick && "cursor-pointer"} onClick={onClick}>
        <Avatar
          src={safePhoto(photo)}
          color={getUserColor(userType) ?? ""}
          alt={concatenateName(attendee)}
          fallback={generateInitials(concatenateName(attendee), 2)}
          append={append}
        />
      </div>

      <div
        className={`meeting-dialog${
          newView ? "-new" : ""
        }--attendee-details flex justify-between ${
          onClick && "cursor-pointer"
        }`}
      >
        <span
          className={children ? "col-span-5 break-words" : "col-span-12"}
          onClick={onClick}
        >
          {concatenateName(attendee)}
        </span>

        {children ? (
          <div
            className="meeting-dialog--attendee-actions col-span-1 max-w-[2rem]"
            onClick={(e) => e.preventDefault()}
          >
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
}
